import React, { useState, useEffect } from 'react';
import Link from "components/Link";
import PropTypes from 'prop-types';
import PubSub from "services/PubSub/";
import OrderTracking from "components/Header/OrderTracking";
import RepeatLastOrder from "components/RepeatLastOrder";
import TagManagerService from 'services/TagManager/';
import OrdersService from 'services/Orders/';
import CartAction from 'actions/Cart';
import { userMenuTxt } from 'config/translate/variables';
import style from './style.scss';//NOSONAR

let actions = [];

const UserMenu = (props) => {
    const [menuUser, setMenu] = useState(false);
    const [lastOrder, setLastOrder] = useState(false);
    const name = props.name ? props.name.split(' ')[0] : '';

    useEffect(() => {
        actions.push(PubSub.register('toggle_menu', closeUserMenu));
        getLastOrder();

        return function cleanup(){
            actions.map(token => PubSub.unregister(token));
        }
    },[]);

    const logOut = () => {
        CartAction.logout(()=> {CartAction.logoutRedirect()});
    };

    const closeUserMenu = (payload) => {
        const value = payload.value;
        setMenu(value ? value.state : false);
    };

    const clickTagManager = (action, tag) => {
        TagManagerService.clickHeader(action, tag);
    };

    const clickMenuUser = () => {
        TagManagerService.clickHeader(`User Menu: Hola ${name}`, 'header');
        setMenu(!menuUser);
        PubSub.dispatch('toggle_minicart', {state: false});
        PubSub.dispatch('close_tracking');
    };

    const getLastOrder = () => {
        OrdersService.getLastOrder().then(data => {
            setLastOrder(data);
        });
    };

    return <span className="new-header-user-menu-desktop" >
        <OrderTracking />
        <button className="new-header-main-name" onClick={() => clickMenuUser()}>Hola, {name} <i className={"font-icn arrow-down" + (menuUser ? ' show' : '')} /></button>
        <div className={'new-header-sup-links-menu-account' + (menuUser ? ' show' : '')} onMouseLeave={() => { setMenu(false) }}>
            <div className={'new-header-user-menu-arrow-up' + (menuUser ? ' show' : '')}></div>
            <ul className='new-header-sup-links-menu-account-items'>
                <li><Link className="new-header-sup-links-text" to="/_secure/account" onClick={() => clickTagManager(userMenuTxt.info, '/_secure/account')}>{userMenuTxt.info}</Link></li>
                <li><Link className="new-header-sup-links-text" to="/_secure/compras" onClick={() => clickTagManager(userMenuTxt.orders, '/_secure/compras')}>{userMenuTxt.orders}</Link></li>
                <li><Link className="new-header-sup-links-text" to="/_secure/listas-de-compras" onClick={() => clickTagManager(userMenuTxt.lists, '/_secure/listas-de-compras')}>{userMenuTxt.lists}</Link></li>
                <li><Link className="new-header-sup-links-text" to="/mis-tarjetas" onClick={() => clickTagManager(userMenuTxt.cards, '/mis-tarjetas')}>{userMenuTxt.cards}</Link></li>
                {lastOrder && <li className="last-order-menu"><RepeatLastOrder/></li>}
                <li onClick={logOut}><a className="new-header-sup-links-text close-session" onClick={() => clickTagManager(userMenuTxt.logout, 'header')}>{userMenuTxt.logout}</a></li>
            </ul>
        </div>
    </span>;
};

UserMenu.propTypes = {
    name: PropTypes.string
}
export default UserMenu;
